// extracted by mini-css-extract-plugin
module.exports = {"comp":"VS_comp__EyiXb"};